import { Accordion, AccordionSummary, Typography } from '@mui/material';
import * as React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Page } from '../subs/Page';

export const WSMonitor = () => {
    return <Page heading = "Workshop status" backButton breadcrumbs>
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>Topic</Typography>
            </AccordionSummary>
        </Accordion>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}>
                <Typography>Allmendinger IT-Solutions - Blankenaufulland (ext), Tom</Typography>
            </AccordionSummary>
        </Accordion>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}>
                <Typography>Ing. -Buero Allmendinger - Allmendinger, Alexander</Typography>
            </AccordionSummary>
        </Accordion>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}>
                <Typography>OPC Foundation - Allemndinger, Alexander</Typography>
            </AccordionSummary>
        </Accordion>
    </Page>
}